/**
 * 用于安全获取对象上的key值
 * 例如a.b.c，a为null，则代码报错，而现在可以safeGet(a, "b.c")
 * @param {object} obj 要获取key的对象
 * @param {string} keyStr 取值字符串, e.g "a.b.c"
 *
 * e.g 如 obj = { a: { b: 1 } }，那么获取b的操作为 safeGet(obj, 'a.b')
 */
export default function(obj, keyStr) {
  const keys = keyStr.split('.');
  let value = obj;
  let key;
  // eslint-disable-next-line
  while ((key = keys.shift()) && value !== null) {
    value = __safeGet(value, key);
  }

  return value;
}

function __safeGet(obj, key) {
  try {
    return obj[key];
  } catch (e) {
    return null;
  }
}
